export default function WhyAdopt() {
  const benefits = [
    {
      icon: 'ri-heart-pulse-line',
      title: 'Healthy, Vet-Checked Kittens',
      description: 'Each kitten receives complete health care and veterinary examination before adoption.'
    },
    {
      icon: 'ri-home-smile-line',
      title: 'Litter Trained',
      description: 'Early training for easy transition to new homes, making your life easier from day one.'
    },
    {
      icon: 'ri-emotion-happy-line',
      title: 'Sweet Personalities',
      description: 'Our kittens are raised to be calm, relaxed companions with gentle temperaments.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Transparent Adoption',
      description: 'No hidden fees, clear communication, and honest information about each kitten.'
    },
    {
      icon: 'ri-eye-line',
      title: 'Beautiful Blue Eyes & Soft Coats',
      description: 'True Ragdoll quality with stunning blue eyes and luxuriously soft, silky fur.'
    },
    {
      icon: 'ri-gift-line',
      title: 'Starter Kit Provided',
      description: 'Food guide, grooming tips, and toy/blanket with scent to help your kitten adjust.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-purple-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Why Choose Ragdoll Gentle Paws Adoption?</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We're committed to providing healthy, happy kittens and exceptional support for new families
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all hover:-translate-y-1"
            >
              <div className="w-16 h-16 mb-6 bg-gradient-to-br from-blue-400 to-purple-300 rounded-2xl flex items-center justify-center">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{benefit.title}</h3>
              <p className="text-gray-600 leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
